var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StringUtils } from '../../utils';
export var Card = function (props) {
    var hasHeader = Boolean(props.title || props.actions);
    return (_jsxs("div", __assign({ className: StringUtils.combineStrings(['localina-card', props.extraClassName]) }, { children: [hasHeader && (_jsxs("div", __assign({ className: "localina-card__header" }, { children: [props.title && _jsx("h3", __assign({ className: "localina-card__title" }, { children: props.title })), props.actions && _jsx("div", __assign({ className: "localina-card__actions" }, { children: props.actions }))] }))), _jsx("div", __assign({ className: StringUtils.combineStrings(['localina-card__body', props.flush && 'flush']) }, { children: props.children }))] })));
};
